module.exports = __webpack_public_path__ + "img/ford-Worth.bb2c7b77.png";